module.exports = __webpack_public_path__ + "static/media/language_icon.e3fdf9c8.svg";